import {useMessages} from "i18n";
import {CloseButton} from "./GameFrame.styles";

/** The ×, shared by the game frame and the slot's placeholder, so a game can always be closed. */
export function CloseGameButton({onClose}: {onClose(): void}) {
	const {games} = useMessages();
	return (
		<CloseButton type="button" aria-label={games.common.closeAria} onClick={onClose}>
			<svg width="14" height="14" viewBox="0 0 12 12" aria-hidden="true">
				<path d="M2 2l8 8M10 2l-8 8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
			</svg>
		</CloseButton>
	);
}
